import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './CONTAINERS/App';
import configureStore from './STORES/index';
import './index.css';
import reportWebVitals from './reportWebVitals';
export const history = createBrowserHistory();
const store = configureStore(history);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
